import { useQueryClient, useQuery, useMutation } from '@tanstack/react-query';
import { notification, Row, Col, Button, Input, Form, Select, Radio, RadioChangeEvent } from 'antd';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Loader from '../../../components/loader';
import { getLanguages, getTranslation, postTranslationUpdate } from '../../../services/api';
import { Editor } from '@tinymce/tinymce-react';
import PageTitle from '../../../components/page-title';

const PlaceholderEdit = () => {
    
    const { id } = useParams();
    const queryClient = useQueryClient();
    const [ ntf, contextHolder ] = notification.useNotification();
    const { data, isLoading, isFetched: isFetchedData } = useQuery(['translation', id], () => getTranslation(id), {enabled: !!id});
    const { data: dataLanguages, isLoading: isLoadingLanguages } = useQuery(['languages'], () => getLanguages(), {enabled: !!id});
    const { mutate: mutatePostTranslationUpdate } = useMutation(postTranslationUpdate);

    const [editorValue, setEditorValue] = useState("");
    const [cleanParagraph, setCleanParagraph] = useState(1)

    const editorInitConfig = {
        height: 300,
        forced_root_block: '',
        plugins: [
            'paste',
            'lists'
        ],
        menubar: 'edit',
        toolbar: 'undo redo | bold italic underline strikethrough | paste pastetext | bullist numlist | removeformat',
        content_style: 'body { font-family: Helvetica,Arial,sans-serif; font-size:16px }'
    }

    const handleSubmit = (values: any) => {
        const placeholderValue = cleanParagraph === 1 ? editorValue.replace(/<p>/gi, '').replace(/<\/p>/gi, '') : editorValue;
        mutatePostTranslationUpdate({value: placeholderValue, variant: cleanParagraph === 1 ? 1 : 2, id: id, key_holder: values.key_holder, language_id: values.language_id }, {
            onSuccess() {
                queryClient.invalidateQueries(['translations']);
                ntf.success({
                    message: `Success`,
                    description: "Updated with success!",
                    placement: "bottomLeft",
                });
            },
            onError() {
                ntf.error({
                    message: `Error`,
                    description: "Something gonne wrong!",
                    placement: "bottomLeft",
                });
            },
        })
    }

    useEffect(() => {
        if (isFetchedData && data) {
          setCleanParagraph(data.variant)
        }
    }, [data, isFetchedData])

    if (isLoading && isLoadingLanguages) {
        return (
            <Row justify="center">
                <Col span={20}>
                    <Row justify="center"><Loader size={50} /></Row>
                </Col>
            </Row>
        )
    }

    const mapLanguages = () => {
        let langs: any = [];
        dataLanguages && dataLanguages.map((lang: any) => {
            langs.push({value: lang.id, label: lang.name})
        })
        return langs;
    }

    if (!isFetchedData) {
        return <></>
    }
    
    return (
        <Row justify="center">
            {contextHolder}
            <PageTitle text={`Placeholder key: ${isFetchedData && data.key_holder}`} />
            <Col span={20}>
                <Row gutter={16}>
                    <Col span={24}>
                        <Form
                            name="translation_edit"
                            style={{ width: "100%"}}
                            layout="vertical"
                            onFinish={handleSubmit}
                        >
                            <Form.Item
                                label="You should not change this key as it will not be updated on our public website."
                                name="key_holder"
                                initialValue={isFetchedData && data.key_holder}
                            > 
                                <Input />
                            </Form.Item>
                            <Form.Item
                                label="You must assign a language to this placeholder. Otherwise it will not be displayed on the website."
                                name="language_id"
                                initialValue={isFetchedData && data.language_id}
                            > 
                                <Select
                                    placeholder="Select language of placeholder"
                                    // onChange={onGenderChange}
                                    allowClear
                                    defaultValue={isFetchedData &&  data.language_id ? data.language_id : 1}
                                    options={mapLanguages()}
                                />
                            </Form.Item>
                            <Form.Item label="Remove paragraphs from the text. This set to YES will clean text out of P elements!">
                                <Radio.Group onChange={(e: RadioChangeEvent) => setCleanParagraph(e.target.value)} value={cleanParagraph} defaultValue={cleanParagraph} >
                                    <Radio value={1}>Yes</Radio>
                                    <Radio value={2}>No</Radio>
                                </Radio.Group>
                            </Form.Item>
                            <Form.Item
                                label="Content value (can be url, html, plain text)"
                            >   
                                <Editor
                                    apiKey='l1bfxq2606zcs9deej0javlspqpdff9g2nlf21ik18hdmdmm'
                                    onInit={() => {
                                        setEditorValue(isFetchedData &&  data.value)
                                    }}
                                    onChange={(content: any) => setEditorValue(content.level.content)}
                                    initialValue={isFetchedData && data.value}
                                    init={editorInitConfig}
                                />
                            </Form.Item>
                            <Form.Item>
                                <Button type="primary" htmlType="submit" className="login-form-button">Save</Button>
                            </Form.Item>
                        </Form>
                    </Col>
                    <Col span={24}>
                        
                    </Col>
                </Row>
            </Col>
        </Row>
      )
}

export default PlaceholderEdit